import React from 'react';
import { connect } from 'react-redux';
import { getDisplayNameHOC, arrayToFlat } from 'app/utils';

/* TODO: backend sometimes doesn't retrieve data */
const BOOKING = {
  screenName: 'HALL 2',
  rating: '16+'
};

const selector = {
  session: ({
    sessions: {
      session: { scheduledFilm, session }
    }
  }) => ({
    title: scheduledFilm?.film?.titleCalculated,
    poster: scheduledFilm?.film?.posterImage,
    cinemaName: session?.cinemaName,
    screenName: session?.screenName,
    date: session?.showtime,
    technologies: arrayToFlat(session?.technologies)?.join(', '),
    rating: scheduledFilm?.ageRating
  }),

  booking: ({ bookings: { booking } }) => ({
    title: booking?.tickets && booking?.tickets[0] && booking?.tickets[0]?.movieName,
    poster: booking?.posterImage,
    cinemaName: booking?.cinemaName,
    screenName: booking?.screenName || BOOKING?.screenName,
    date: booking?.session ? booking?.session?.showtime : booking?.bookingDate,
    technologies: arrayToFlat(booking?.technologies).join(', '),
    rating: booking?.ageRating || BOOKING.rating
  })
};

const withTicket = type => WrappedComponent => {
  const Ticket = props => <WrappedComponent {...props} />;

  Ticket.displayName = `withTicket(${getDisplayNameHOC(WrappedComponent)})`;

  return connect(selector[type])(Ticket);
};

export default withTicket;
